import TranslationMixin from '../assets/TranslationMixin.js'
import countriesData from '../assets/countries.json'
import _ from 'lodash'

export default {
  mixins: [TranslationMixin],
  props: {
    value: {
      type: Object
    },
    suggestions: {
      type: Array,
      default () {
        return []
      }
    },
    allowUnattached: {
      type: Boolean,
      default () {
        return true
      }
    },
    countries: {
      type: Array,
      default () {
        return countriesData
      }
    },
    country: {
      type: String,
      default () {
        return null
      }
    },
    url: {
      type: String,
      default () {
        return '/api/orgs/'
      }
    },
    allowInternational: {
      type: Boolean,
      default () {
        return false
      }
    },
    orgTypes: {
      type: Array,
      default () {
        return ['CLUB']
      }
    },
    fieldName: {
      type: String,
      default () {
        return 'affiliation'
      }
    }
  },
  data () {
    return {
      open: false,
      output: {},
      text: '',
      orgMode: 'affiliated',  // working property for props.orgMode
      club: '',
      currentCountry: '',
      matches: [],
      clubCode: '',
      newClub: false,
      current: 0,
      tempOutput: {},
      orgType: ''
    }
  },
  methods: {

    // Triggered the input event to cascade the updates to
    // parent component
    changeCountry (ev) {
      var self = this
      var countrySelect = ev.target
      self.currentCountry = countrySelect.value
    },
    updateValue (value) {
      if (this.open === false) {
        this.open = true
        this.current = 0
      }
      this.$emit('input', value)
    },

    // When up arrow pressed while suggestions are open
    up () {
      if (this.current > 0) {
        this.current--
      }
    },

    // When down arrow pressed while suggestions are open
    down () {
      if (this.current < this.matches.length - 1) {
        this.current++
      }
    },

    // For highlighting element
    isActive (index) {
      return index === this.current
    },

    // When one of the suggestion is clicked
    suggestionClick (index) {
      var self = this
      var text = ''
      var found = self.matches[index]
      if (found.code) {
        self.$emit('input', found.code)
        self.output.code = found.code
        text = found.code + ' - '
      } else {
        text = ''
        delete self.output.code
      }
      text += found.name
      self.output.name = found.name
      if (String(self.orgMode) === 'international') text += ' [' + self.currentCountry + ']'
      if (found.id) {
        self.output.id = found.id
      }
      self.open = false
      self.text = text
    },
    // When enter key pressed on the input
    enter () {
      this.suggestionClick(this.current)
    },
    getClubs: function (v) {
      var self = this
      var lv = v.toLowerCase()
      if (self.suggestions.length) {
        self.matches = self.suggestions.filter((obj) => {
          var codeMatch = obj[0] ? obj[0].toLowerCase().indexOf(lv) >= 0 : false
          var nameMatch = obj[1] ? obj[1].toLowerCase().indexOf(lv) >= 0 : false
          return codeMatch || nameMatch
        }).map((obj) => {
          return {code: obj[0], name: obj[1]}
        })
      } else
        if (v.length > 1) {
          var url = self.url + '?'
          if (self.currentCountry) url += 'country=' + encodeURIComponent(self.currentCountry) + '&'
          self.matches = []
          self.orgTypes.forEach(function (ot) {
            var uri = url + 'org_type=' + encodeURIComponent(ot) + '&query=' + encodeURIComponent(v)
            self.$http.get(uri).then(response => {
              if (response.body.options) {
                self.matches = self.matches.concat(response.body.options)
                _.sortBy(self.matches, ['code', 'name'])
              }
            })
          })
        }
    }
  },
  computed: {
    openSuggestion () {
      return this.matches.length !== 0 && this.open === true
    }
  },
  watch: {
    text: function (newValue) {
      if (!newValue.length) {
        this.output = {}
      } else {
        this.getClubs(newValue)
      }
    },
    orgMode: function (val) {
      if (String(val) === 'unattached') {
        this.tempOutput = this.output
        this.output = {code: 'UNATT', name: 'Not a club member'}
        this.text = ''
      } else {
        if (String(val) === 'affiliated') {
          this.output = this.tempOutput
          this.tempOutput = {}
        }
      }
    // this.text = ''
    }
  },
  created: function () {
    var self = this

    if (typeof self.value === 'string') {
      self.output = {}
      self.orgMode = 'affiliated'
      self.text = self.value
    } else {
      self.orgMode = 'unattached'
      if (!self.value) {
        self.output = {code: 'UNATT', name: 'Not a club member'}
        // console.log("set output to", self.output);
      } else {
        self.output = self.value
      }

      // console.log("output equals", self.output);
      if (String(self.output.code) !== 'UNATT') {
        if (self.value.country && self.allowInternational) {
          self.orgMode = 'international'
        } else {
          self.orgMode = 'affiliated'
        }
      }
      // console.log("orgMode =", self.orgMode);
      self.text = ''
      if (self.output.code) {
        self.text = self.output.code
      }
      if (self.output.name) {
        if (self.text.length) self.text += ' - '
        self.text += self.output.name
      }
      if (self.output.country) {
        self.text += ' [' + self.output.country + ']'
      }
    }
  },
  mounted () {
    var self = this
    var orgTypes = self.orgTypes.map(function (ot) {
      return ot[0].toUpperCase() + ot.slice(1).toLowerCase()
    })
    self.orgType = orgTypes.join('/')
  }
}



// WEBPACK FOOTER //
// ./src/assets/clubpicker.js